import React from "react";
import { Link } from "react-router-dom";
import { AWS_URL } from "../config/constants";

/**
 * Renders the RedCircle logo with theme-aware text logo
 * Consolidates repeated logo rendering from GuestLayout and PublicLayout
 *
 * @param {Object} props
 * @param {string} props.variant - 'login' | 'default' - controls logo class styling
 * @param {boolean} props.centered - Whether to center the logo container
 * @param {string} props.to - Link destination (default: "/")
 * @param {Object} props.style - Additional styles for the Link container
 */
const Logo = ({
  variant = "default",
  centered = false,
  to = "/",
  style = {},
}) => {
  const logoClass =
    variant === "login" ? "logo-red-circle-login" : "logo-red-circle";

  const getThemedTextLogo = () => {
    const isLightTheme = localStorage.getItem("theme") === "theme-light";
    return isLightTheme ? "RedCircleBlack.png" : "RedCircleRed.png";
  };

  const containerStyle = {
    gap: "7.24px",
    ...style,
  };

  const content = (
    <>
      <div
        className="d-flex justify-content-center"
        style={{ width: "100%" }}
      >
        <img
          className={logoClass}
          src={`${AWS_URL}logo/logoRedCircle.png`}
          alt="RedCircle Logo"
        />
      </div>
      <div
        className="d-flex justify-content-center"
        style={{ width: "100%" }}
      >
        <img
          className={logoClass}
          src={`${AWS_URL}logo/${getThemedTextLogo()}`}
          alt="RedCircle"
        />
      </div>
    </>
  );

  if (centered) {
    return (
      <Link to={to} style={containerStyle}>
        <div style={{ width: "100%", textAlign: "-webkit-center" }}>
          {content}
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={to}
      style={containerStyle}
      className="d-flex flex-column align-items-center"
    >
      {content}
    </Link>
  );
};

export default Logo;
